var app = app || {};

app.ToricCalc = {

    _userSetSpherical   : 0,
    _userSetCylindrical : 0,
    _userSetAxis        : 0,	
    _rotation           : 0,
    _backVertexDistance : 0,
    _meridianOnePower   : 0,
    _meridianTwoPower   : 0,

    init: function()
    {
        // console.log('init Toric calc')

        this.setErrorPrompt();

        return;
    },

    getTheoreticalValues: function(arg1, arg2, arg3)
    {
        var loc1=null;
        var loc2=arg1.spher / (1 - 0.001 * arg3 * arg1.spher);
        var loc3=(arg1.spher + arg1.cyl) / (1 - 0.001 * arg3 * (arg1.spher + arg1.cyl));
        var loc4=(loc4 = (loc4 = arg1.axis + arg2) > 180 ? loc4 - 180 : loc4) < 0 ? loc4 + 180 : loc4;

        return loc1 = new RefractionData(loc2, loc3 - loc2, loc4);
        
    },

    getAllLensDataSets: function(arg1, arg2, arg3, arg4, isMultiline)
    {
        /*
        arg1 = refractiondata
        arg2 = string
        arg3 = uint 
        arg4 = uint 
        isMultiline = bool 
        
        return Array
        */
        
        // console.log('getAllLensDataSets: ');
        // console.log("arg2: "+arg2)
        // console.log("arg3: "+arg3)
        // console.log("arg4: "+arg4)
    
        arg3 = arg3;
        arg4 = arg4;                        
        
        var loc2=null;
        var loc3=null;
        var loc4=null;
        var loc5=null;
        var loc1=new Array();
        var loc6=0;
        while (loc6 < data.RawLensData.AVAILABLE_LENSES.length) 
        {
            loc3 = data.RawLensData.AVAILABLE_LENSES[loc6];
            loc4 = (isMultiline==true) ? data.RawLensData.AVAILABLE_LENS_LABELS_MULTILINE[loc6] : data.RawLensData.AVAILABLE_LENS_LABELS[loc6];
            // console.log('!!!! loc4: '+loc4)
            loc2 = this.getLensFromRefractionAndUserValues(arg1, data.RawLensData.AVAILABLE_LENSES[loc6], arg3, arg4);
            if (arg2 != data.RawLensData.AVAILABLE_LENSES[loc6]) 
            {
                loc1.push({"lens":loc3, "label":loc4, "data":loc2});
            }
            else 
            {
                loc1.splice(0, 0, {"lens":loc3, "label":loc4, "data":loc2});
            }
            ++loc6;
        }
        //console.log("loc1: "+loc1)
        return loc1;
    },

    getLensFromRefractionAndUserValues: function(arg1, arg2, arg3, arg4)
    {
        /*
        arg1 = refractiondata
        arg2 = string
        arg3 = int 
        arg4 = uint 
        
        return RefractionData
        */          
        
        var loc2=null;
        var loc3=null;
        var loc4=null;
        var loc5=null;
        var loc6=NaN;
        var loc7=NaN;
        var loc8=NaN;
        var loc18=0;
        var loc19=NaN;
        var loc20=NaN;
        var loc21=NaN;
        var loc22=NaN;
        var loc23=NaN;
        var loc1=new RefractionData(0, 0, 0);
        loc3 = (loc2 = this.getLensData(arg2)).sphereValues;
        loc4 = loc2.cylValues;
        loc5 = loc2.axisValues;
        loc6 = loc3[0];
        loc7 = loc3[(loc3.length - 1)];
        loc8 = loc4[0];
        var loc9=arg1.spher / (1 - 0.001 * arg4 * arg1.spher);
        var loc10=(arg1.spher + arg1.cyl) / (1 - 0.001 * arg4 * (arg1.spher + arg1.cyl));
        loc1.spher = loc9;
        loc1.cyl = loc10 - loc9;
        var loc11=(loc11 = (loc11 = arg1.axis + arg3) > 180 ? loc11 - 180 : loc11) < 0 ? loc11 + 180 : loc11;
        loc1.axis = loc11;
        var loc12=loc1.cyl > data.RawLensData.MINIMUM_CYLINDRIACL_TORIC;
        var loc13=loc8 - loc1.cyl > data.RawLensData.MAXIMUM_CYLINDER_TORIC;
        if (loc12 || loc13) 
        {
            return null;
        }
        
        loc18 = this.getNearestCYL(loc1.cyl, loc4);
        if (isNaN(loc18)) 
        {
            return null;
        }
        loc19 = loc4[loc18];
        loc20 = loc4[loc18 + 1];
        loc20 = isNaN(loc20) ? loc19 : loc20;
        loc1.cyl = Math.abs(loc19 - loc1.cyl) < Math.abs(loc20 - loc1.cyl) ? loc19 : loc20;
        var loc14=loc1.cyl > data.RawLensData.MINIMUM_CYLINDRIACL_TORIC;
        var loc15=loc1.spher + data.RawLensData.MAXIMUM_SPERICAL_TORIC < loc6;
        var loc16=loc1.spher - data.RawLensData.MAXIMUM_SPERICAL_TORIC > loc7;
        var loc17=arg2 == data.RawLensData.LENS_PURE_2HD && loc1.spher > 0 && loc1.cyl < -1.75;
        if (loc14 || loc15 || loc16 || loc17) 
        {
            return null;
        }
        loc18 = this.getNearestLTEQ(loc1.spher, loc3);
        if (isNaN(loc18)) 
        {
            return null;
        }
        loc21 = loc3[loc18];
        loc22 = loc3[loc18 + 1];
        loc22 = isNaN(loc22) ? loc21 : loc22;
        loc1.spher = Math.abs(loc21 - loc1.spher) < Math.abs(loc22 - loc1.spher) ? loc21 : loc22;
        loc18 = this.getNearest(loc1.axis, loc5);
        if (isNaN(loc18)) 
        {
            return null;
        }
        loc23 = loc5[loc18];
        if (arg2 == data.RawLensData.LENS_SOFLENS_DAILY && Math.abs(loc1.axis - loc23) > 20) 
        {
            return null;
        }
        loc1.axis = loc23 != 0 ? loc23 : 180;
        return loc1;
    },

    getOcularRefraction: function(arg1, arg2)
    {
        /*
        arg1 = refractiondata
        arg2 = uint
        
        return RefractionData
        */
        arg2 = arg2
        var loc1=arg1.spher / (1 - 0.001 * arg2 * arg1.spher);
        var loc2=(arg1.spher + arg1.cyl) / (1 - 0.001 * arg2 * (arg1.spher + arg1.cyl));
        var loc3=getNextNearest(loc1, 0.25);
        var loc4=getNextNearest(loc2, 0.25) - getNextNearest(loc1, 0.25);
        var loc5=(loc5 = arg1.axis) != 0 ? loc5 : 180;
        return new RefractionData(loc3, loc4, loc5);
    },

    getLensData: function(arg1)
    {
        /* arg1 = string
        return object
        */
        var loc1=new Object();
        var loc2=arg1;
        switch (loc2) 
        {
            case data.RawLensData.to_LENS_PURE:
            {
                loc1.sphereValues = data.RawLensData.PV_SPHERE_VALUES;
                loc1.cylValues = data.RawLensData.PV_CYLINDER_VALUES;
                loc1.axisValues = data.RawLensData.PV_AXIS_VALUES;
                break;
            }
            case data.RawLensData.to_LENS_PURE_2HD:
            {
                loc1.sphereValues = data.RawLensData.PV_2HD_SPHERE_VALUES;
                loc1.cylValues = data.RawLensData.PV_2HD_CYLINDER_VALUES;
                loc1.axisValues = data.RawLensData.PV_2HD_AXIS_VALUES;
                break;
            }
            case data.RawLensData.to_LENS_SOFLENS:
            {
                loc1.sphereValues = data.RawLensData.SLT_SPHERE_VALUES;
                loc1.cylValues = data.RawLensData.SLT_CYLINDER_VALUES;
                loc1.axisValues = data.RawLensData.SLT_AXIS_VALUES;
                break;
            }
            case data.RawLensData.to_LENS_SOFLENS_DAILY:
            {
                loc1.sphereValues = data.RawLensData.SLD_SPHERE_VALUES;
                loc1.cylValues = data.RawLensData.SLD_CYLINDER_VALUES;
                loc1.axisValues = data.RawLensData.SLD_AXIS_VALUES;
                break;
            }
            default:
            {
                loc1.sphereValues = data.RawLensData.PV_SPHERE_VALUES;
                loc1.cylValues = data.RawLensData.PV_CYLINDER_VALUES;
                loc1.axisValues = data.RawLensData.PV_AXIS_VALUES;
                break;
            }
        }
        return loc1;
    },

    getNearestCYL: function(minVal, arr){

        var loc2 = NaN;
        var loc3=NaN;
        var loc5=false;
        var loc1=1000;
        var loc4=minVal < 0;
        var loc6=0;
        while (loc6 < arr.length) 
        {
            loc5 = arr[loc6] < 0;
            if (loc4 == loc5 && arr[loc6] <= minVal + data.RawLensData.CYL_THRESHOLD) 
            {
                if ((loc2 = Math.abs(Math.abs(arr[loc6]) - Math.abs(minVal))) < loc1) 
                {
                    loc1 = loc2;
                    loc3 = loc6;
                }
            }
            ++loc6;
        }
        return loc3;
    },

    getNearestLTEQ: function(minVal, arr){
        var loc2=NaN;
        var loc3=NaN;
        var loc5=false;
        var loc1=1000;
        var loc4=minVal < 0;
        var loc6=0;
        while (loc6 < arr.length) 
        {
            loc5 = arr[loc6] < 0;
            if (loc4 == loc5 && arr[loc6] <= minVal) 
            {
                if ((loc2 = Math.abs(Math.abs(arr[loc6]) - Math.abs(minVal))) < loc1) 
                {
                    loc1 = loc2;
                    loc3 = loc6;
                }
            }
            ++loc6;
        }
        return loc3;
    },

    getNearest: function(arg1, arr){
        var loc2=NaN;
        var loc3=NaN;
        var loc5=false;
        var loc7=NaN;
        var loc8=NaN;
        var loc1=1000;
        var loc4=arg1 < 0;
        var loc6=0;
        while (loc6 < arr.length) 
        {
            loc5 = arr[loc6] < 0;
            if (loc4 == loc5) 
            {
                if ((loc2 = Math.abs(Math.abs(arr[loc6]) - Math.abs(arg1))) < loc1) 
                {
                    loc1 = loc2;
                    loc3 = loc6;
                }
                else if (loc2 == loc1) 
                {
                    loc7 = arr[loc6];
                    loc8 = arr[loc3];
                    if (arg1 >= 0 && arg1 <= 45) 
                    {
                        loc3 = loc7 < loc8 ? loc6 : loc3;
                    }
                    else if (arg1 > 45 && arg1 <= 90) 
                    {
                        loc3 = loc7 > loc8 ? loc6 : loc3;
                    }
                    else if (arg1 > 90 && arg1 < 135) 
                    {
                        loc3 = loc7 < loc8 ? loc6 : loc3;
                    }
                    else if (arg1 >= 135) 
                    {
                        loc3 = loc7 > loc8 ? loc6 : loc3;
                    }
                }
            }
            ++loc6;
        }
        return loc3;
    },

    setErrorPrompt: function()
    {
        var vbCont =  $('div#vbCont');
        var vbRTCont = $('div#vbRtCont');
        var htmlListNode = "<div class='resultsList'><h4>"+data.RawLensData.to_DEFAULT+"</h4></div>"
        vbCont.append(htmlListNode)
        vbRTCont.append(htmlListNode)
        return;
    }

}



